import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ListItem\CreateListItemController::__invoke
* @see app/Http/Controllers/ListItem/CreateListItemController.php
* @route '/api/list-item'
*/
const CreateListItemController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateListItemController.url(options),
    method: 'post',
})

CreateListItemController.definition = {
    methods: ["post"],
    url: '/api/list-item',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ListItem\CreateListItemController::__invoke
* @see app/Http/Controllers/ListItem/CreateListItemController.php
* @route '/api/list-item'
*/
CreateListItemController.url = (options?: RouteQueryOptions) => {
    return CreateListItemController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListItem\CreateListItemController::__invoke
* @see app/Http/Controllers/ListItem/CreateListItemController.php
* @route '/api/list-item'
*/
CreateListItemController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateListItemController.url(options),
    method: 'post',
})

export default CreateListItemController